module.exports = __webpack_public_path__ + "img/flowers-8219261_1280_thumb.e7c560c6.png";